// extracted by mini-css-extract-plugin
export default {"container":"NFT_container__ejP00"};